import { type BoxProps, Box as MuiBox } from '@mui/material';
import { forwardRef } from 'react';

export const Box = (props: BoxProps) => <MuiBox {...props} />;

export const RefBox = forwardRef((props: BoxProps, ref) => (
  <MuiBox {...props} ref={ref} />
));
